import axios from 'axios';

declare global {
  interface Window {
      csrf_token: string;
      UID: string;
      EMAIL: string;
  }
}
const api = axios.create({
    headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': window.csrf_token,
        'X-UID': window.UID,
        'X-EMAIL': window.EMAIL,
        'csrftoken': window.csrf_token
    },
    responseType: 'json'
});

const replaceParamsInStr = (str: string, obj: any) => {
  if (obj) {
    for (let [key, value] of Object.entries(obj)) {
      str = str.replace(`{${key}}`, value as any);
    }
  }
  return str;
};

export { api, replaceParamsInStr };